import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { TextFieldWrapper } from '.'

const InputWrapper = styled.div`
  input {
    width: 100%;
    padding: 18px;
    margin: 8px 0 8px;
    outline: 0;
    color: ${({ theme, readOnly, disabled }) =>
      readOnly || disabled ? theme.colors.labelGrey : 'black'};
    text-overflow: ellipsis;
    border: 1px solid
      ${({ theme, error, success }) =>
        error
          ? theme?.['-ds-error-300']?.value
          : success
          ? theme.brand.jungle
          : theme.colors.textGreyLight};

    ${({ rounded }) =>
      rounded &&
      `
      border-radius: 6px;
    `}

    &:focus {
      border-color: ${({ theme }) => theme.brand.jungle};
    }
  }
`

class PlacesInput extends React.Component {
  constructor(props) {
    super(props)
    this.Autocomplete = null
    this.AutocompleteInstance = null
  }

  componentDidMount() {
    // google maps script loading is deferred -- component needs to be able to wait until it has finished loading
    if (window.google) {
      this.Autocomplete = google.maps.places.Autocomplete
      this.instantiateAutocomplete()
    }

    const googleScript = document.getElementById('google-maps-script')
    googleScript.addEventListener('load', () => {
      this.Autocomplete = google.maps.places.Autocomplete
      this.instantiateAutocomplete()
    })
  }

  handleChange = (e) => {
    const { onSelectChange, input } = this.props

    input.onChange(e)

    if (onSelectChange) {
      onSelectChange({
        latitude: null,
        longitude: null,
        googlePlaceId: null,
      })
    }
  }

  handleSelect() {
    const { onSelectChange } = this.props
    const {
      formatted_address,
      geometry: { location },
      place_id,
    } = this.AutocompleteInstance.getPlace()

    if (onSelectChange) {
      onSelectChange({
        location: formatted_address,
        latitude: location.lat(),
        longitude: location.lng(),
        googlePlaceId: place_id,
      })
    }
  }

  instantiateAutocomplete() {
    const { onlyRegions, country } = this.props
    const additionalProps = onlyRegions
      ? {
          types: ['(regions)'],
        }
      : {
          componentRestrictions: {
            country,
          },
        }
    this.AutocompleteInstance = new this.Autocomplete(this.input, {
      ...additionalProps,
    })
    // Prevent the browser autocomplete menu from appearing.
    setTimeout(
      () => this.input?.setAttribute('autocomplete', 'new-location'),
      200
    )
    this.AutocompleteInstance.addListener('place_changed', () =>
      this.handleSelect()
    )
  }

  componentDidlUnmount() {
    this?.Autocomplete?.removeListener('place_changed', () =>
      this.handleSelect()
    )
  }

  render() {
    const {
      input,
      meta: { error, submitFailed },
      rounded = true,
      placeholder,
    } = this.props

    return (
      <TextFieldWrapper>
        <InputWrapper error={error && submitFailed} rounded={rounded}>
          <input
            id={input.name}
            name={input.name}
            type="text"
            placeholder={placeholder || 'Enter the address or location'}
            // browser-level autocomplete clashes with location lookup autocomplete
            autoComplete="off"
            ref={(node) => {
              this.input = node
            }}
            onChange={this.handleChange}
            value={input.value}
          />
        </InputWrapper>
      </TextFieldWrapper>
    )
  }
}

export default connect()(PlacesInput)
